<template>
  <div id="AboutMeText4" :class="sectionClass">
    <p
      >“Growing up my parents would work late so I had a lot of freedom. My
      first interactions with art were from the video games and cartoons that I
      would watch religiously. My dad always had his work laptop laying around
      and I would nag him to play on it any chance I got, I was obsessed with
      Microsoft paint and grew up very comfortable creating works digitally at a
      young age.”</p
    >
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 10% 0% 10%;
}

.sectionMobile {
  padding: 40% 0% 40%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText4.vue